import { Box, Typography } from '@mui/material'
import styled from 'styled-components'
import { ACCENT_BLUE } from '../../../../utils/brand-colors'

export const ItemContainer = styled(Box)<{ $selected?: boolean }>`
  margin-top: 10px;
  cursor: pointer;
  overflow: hidden;
  border-radius: 10px;
  background: #ffffff;
  border: 1px solid ${({ $selected }) => ($selected ? ACCENT_BLUE : '#E0E0E0')};
  border-left: 4px solid
    ${({ $selected }) => ($selected ? ACCENT_BLUE : '#BDBDBD')};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
`

export const NameContainer = styled(Box)<{ $selected?: boolean }>`
  padding: 12px 12px 8px;
  background: ${({ $selected }) => ($selected ? '#E8F3FC' : '#ffffff')};
`

export const Name = styled(Typography)`
  font-size: 15px !important;
  line-height: 1.35 !important;
  font-weight: 700 !important;
  color: #1a1a1a !important;
`

export const TripId = styled(Typography)<{ $selected?: boolean }>`
  font-size: 13px !important;
  line-height: 1.35 !important;
  font-weight: 600 !important;
  color: ${({ $selected }) => ($selected ? ACCENT_BLUE : '#666666')} !important;
`
